import React from 'react'
import { getFileName } from '../../../helpers/FileCaching';

import classes from './ExternalArticles.module.scss';
import globalJson from '../../../data/global';
import FooterImage from './FooterImage/FooterImage';


function onExternalArticleClick(event){
    window.gtag('event', "External Article clicked", {
        'event_category': globalJson.tracking.ga_category,
        'event_label': "External Article clicked "+ event.url,
        'value':10
      });
}

function ExternalArticles(props){
	
	const externalArticles = props.content.article_links.map(item => {
		let articles =
		<article key={item.id} className={` ${classes['external_articles__article']} col-12 col-md-6 col-lg-3`}>
				<a onClick={() => onExternalArticleClick(item)}  href={item.url} target='blank' className={`radial-link ${classes['external_articles__article--link']}`}>
					<div className={`remove-img-color smooth`}>
						<div className={` ${classes['external_articles__article_hover']}`}>
							<div className={`remove-img-element ${classes['external_articles__article--container-image']}`}>
								<img src={getFileName(props.globalImages, item.image)} className={`${classes['external_articles__article--image']}`} alt={item.imageTitle} />
							</div>
						</div>
						<header className={classes['external_articles__article--title']}>{item.title}</header>
					</div>
				</a>
		</article>

		return articles
	});


	return (
		<section id={"external_articles"} className={classes.external_articles}>
			<FooterImage content={globalJson.footerImage} windowSize={props.windowSize}/>
			<div className={classes['external_articles__wrapper']}>

				<div className={`text_subtitle_wrapper ${classes.external_articles__subtitle_wrapper}`}>
					<p className={`${classes.external_articles__header}`}>{props.content.title}</p>
				</div>
				<div className={classes['external_articles__article-wrapper']}>
					{externalArticles}
					
				</div>
			</div>
			
		</section>
	)
}

export default ExternalArticles